export default __webpack_public_path__ + "static/Logo-47e94fe6ee167885f60acefb98045b49.svg";